/* eslint-disable arrow-body-style */
/* eslint-disable */
import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useParams } from 'react-router-dom';

import { SlGraph } from 'react-icons/sl';
// TODO: INVESTIGAR PQ O GRID2 NÃO FUNCIONA COM A CONFIG DE RESPONSIVIDADE DAS COLUNAS E SUBSTITUIR O GRID PELO GRID2
import api, { authHeader } from '../../../../../../services/API/apiConfig';
import { BarChart } from '../../../../../components/singleComponents/dashboards/BarChart';
import { LineChart } from '../../../../../components/singleComponents/dashboards/LineChart';
import { PieChart } from '../../../../../components/singleComponents/dashboards/PieChart';
import {
  BarChartStyled,
  ButtonGroupStyled,
  DataContainerStyled,
  MonthsBtnStyled,
  NoInfoContainerStyled,
  PieChartStyled,
  SchedulesChartStyled,
  SchedulesHeaderStyled,
  SchedulesTitleStyled,
  SelectedLengthBtnStyled,
  StatusSymbolStyled,
  TitleContainerStyled,
  YearOptionStyled,
  YearsSelectStyled,
} from './ConstructionDashboard.styles';

export function ConstructionDashboard() {
  const { id: constructionId } = useParams();

  const [constructionName, setConstructionName] = useState(null);
  const [barChartData, setBarChartData] = useState([]);
  const [pieChartData, setPieChartData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [budgetItems, setBudgetItems] = useState([]);
  const [hasBudget, setHasBudget] = useState(false);
  const [years, setYears] = useState([]);
  const [monthsLength, setMonthsLength] = useState(0);
  const [selectedYear, setSelectedYear] = useState(0);
  const [noInfo, setNoInfo] = useState(false);

  const getStatusColor = (status) => {
    if (status === 'Concluído') return '#2ed059';
    if (status === 'Em andamento') return '#e9ad5c';
    return '#373737';
  };

  useEffect(() => {
    api
      .get('/constructions', {
        headers: authHeader(),
      })
      .then(({ data }) => {
        setConstructionName(data.data.find((item) => item.id === +constructionId).name);
      });

    api
      .get(`/constructions/${constructionId}/budgets`, {
        headers: authHeader(),
      })
      .then((res) => {
        const {
          data: { items_attributes },
        } = res.data;
        setHasBudget(!!items_attributes.length);

        const items = []

        function extractItems(item) {
          if (item.items_attributes.length === 0) {
            items.push(item);
          } else {
            item.items_attributes.forEach(subItem => {
              extractItems(subItem);
            });
          }
        }

        if (items_attributes.length) {
          items_attributes.forEach((item) => { extractItems(item); });
        }

        items.forEach(({ is_finalized, has_payables }, index, array) => {
          let status;
          if (is_finalized) {
            status = 'Concluído';
          } else if (has_payables) {
            status = 'Em andamento';
          } else {
            status = 'Não iniciado';
          }
          array[index].status = status;
        });
        setBudgetItems(items);
      });

    api
      .get(`/constructions/${constructionId}/dashboard?category_limit=10`, {
        headers: authHeader(),
      })
      .then((response) => {
        const { bar_chart: barChart, pie_chart: pieChart } = response.data.data;

        if (!barChart.length && !pieChart.length) {
          setNoInfo(true);
        }

        setPieChartData(pieChart);

        const accumulated = [];
        if (barChart.length) {
          barChart.forEach((d) =>
            d.monthly_data.forEach((month) => {
              month.month = `${month.month} / ${d.year}`;
              accumulated.push(month);
            })
          );
        }

        setYears(barChart.map(({ year }) => year));
        setBarChartData([
          { year: 'default', monthly_data: accumulated },
          ...barChart,
        ]);
        setFilteredData([
          { year: 'default', monthly_data: accumulated },
          ...barChart,
        ])
      })
      .catch((err) => {
        console.log(err);
        setNoInfo(true);
      });
  }, []);

  useEffect(() => {
    if (monthsLength) {
      const newFilteredData = barChartData.map((item) => ({
        year: item.year,
        monthly_data: item.monthly_data.slice(-monthsLength),
      }))
      setFilteredData(newFilteredData)
    } else {
      setFilteredData(barChartData)
    }
  }, [monthsLength]);

  return noInfo ? (
    <NoInfoContainerStyled component={Paper}>
      <SlGraph size={300} />
      <Typography variant="h2">Nenhum dado adicionado a obra</Typography>
    </NoInfoContainerStyled>
  ) : (
    <>
      <TitleContainerStyled container justifyContent="space-between">
        <Grid item alignSelf="center">
          <Typography variant="h2" component="h2">{constructionName}</Typography>
        </Grid>
        {/* <Grid item>
            <Button  variant="contained">
              <IosShareIcon />
              Exportar PDF
            </Button>
          </Grid> */}
      </TitleContainerStyled>

      <DataContainerStyled container>
        <Grid item container alignItems="center" sx={{ mb: 5 }}>
          <Grid item>
            <ButtonGroupStyled
              variant="contained"
              aria-label="Basic button group"
            >
              {[3, 6, 12].map((months) => {
                const BtnComponent = months === monthsLength
                  ? SelectedLengthBtnStyled
                  : MonthsBtnStyled

                return (
                  <BtnComponent
                    key={`${months}-months-btn`}
                    onClick={() =>
                      setMonthsLength(months === monthsLength ? 0 : months)
                    }
                  >
                    {`${months} meses`}
                  </BtnComponent>
                )
              })}
            </ButtonGroupStyled>
          </Grid>

          <Grid item sx={{ ml: 4 }}>
            <Grid container alignItems="center">
              <Grid item>
                <Typography component="h4" variant="h3">
                  Ano:
                </Typography>
              </Grid>
              <Grid item>
                <YearsSelectStyled
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                  <YearOptionStyled value={0}>Todos</YearOptionStyled>
                  {years.map((year, index) => (
                    <YearOptionStyled key={year} value={index + 1}>
                      {year}
                    </YearOptionStyled>
                  ))}
                </YearsSelectStyled>
              </Grid>
            </Grid>
          </Grid>

          {/* <Grid item sx={{ ml: 'auto' }}>
              <Typography component="p" variant="body1">
                Atualizado há 1 dia atrás
              </Typography>
            </Grid> */}
        </Grid>

        <Grid item container spacing={2} justifyContent="space-between">
          <Grid item sx={{ width: '60%' }}>
            <BarChartStyled>
              <LineChart
                data={filteredData}
                selectedYear={selectedYear}
                title="Acumulado"
              />
            </BarChartStyled>
            <BarChartStyled>
              <BarChart
                data={filteredData}
                selectedYear={selectedYear}
                title="Lançamentos"
              />
            </BarChartStyled>
          </Grid>

          <Grid item sx={{ width: '40%' }}>
            <PieChartStyled>
              <PieChart data={pieChartData} />
            </PieChartStyled>
            {hasBudget ? (
              <SchedulesChartStyled>
                <SchedulesTitleStyled component="h4" variant="h3">
                  Evolução da obra
                </SchedulesTitleStyled>
                <SchedulesHeaderStyled container>
                  <Grid item sx={{ width: '60%' }}>
                    <Typography sx={{ fontWeight: 600 }}>Etapa</Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontWeight: 600 }}>Status</Typography>
                  </Grid>
                </SchedulesHeaderStyled>
                {budgetItems.map(({ description, status }, index) => (
                  <SchedulesHeaderStyled container>
                    <Grid item sx={{ width: '60%' }}>
                      <Typography>{description}</Typography>
                    </Grid>
                    <Grid item>
                      <Grid container>
                        <Grid item>
                          <StatusSymbolStyled
                            sx={{ backgroundColor: getStatusColor(status) }}
                          />
                        </Grid>
                        <Grid item>
                          <Typography component="span">{status}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </SchedulesHeaderStyled>
                ))}
              </SchedulesChartStyled>
            ) : null}
          </Grid>
        </Grid>
      </DataContainerStyled>
    </>
  );
}
